module.exports = __webpack_public_path__ + "static/img/trial1.ebe8712f.svg";